/**
 * @ngdoc controllers
 * @memberof mercury.modules.time.payroll.paytypes.allowance
 * @name TimeStaffEditPayrollAllowancesCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimePayrollAllowanceStaffEditorCtrl', ["$filter", "$scope", "TimePayrollAllowance", "userinfo", function($filter, $scope, TimePayrollAllowance, userinfo) {
  $scope.quantityTypeMap = {
    0: {description: 'Fixed Rate', rate: 'money'},
    1: {description: 'Hours Worked', rate: 'money'},
    2: {description: 'Staff Orders', rate: 'percent'},
    3: {description: 'Staff Sales', rate: 'percent'}
  };

  if (userinfo.companyHasPermission('Payroll,Salary')) {
    TimePayrollAllowance.getAll()
    .then(function(result) {
      $scope.paytypes = result;
    });
  }

  $scope.addAllowanceOptions = function() {
    var typeOptions = [];

    if (!$scope.staff) {
      return typeOptions;
    }

    angular.forEach($scope.paytypes, function(paytype) {
      if (paytype.autoAdd == 3) {
        var existing = $filter('filter')($scope.staff.defaultPaytypes, {paytypeId: paytype.id});

        if (existing.length === 0) {
          typeOptions.push(paytype);
        }
      }
    });
    return typeOptions;
  };

  $scope.addDefaultAllowance = function(selectedAllowance) {
    $scope.staff.defaultPaytypes.push({
      paytypeName: selectedAllowance.name,
      paytypeId: selectedAllowance.id,
      paytypeDefaultQuantity: selectedAllowance.defaultQuantity,
      paytypeDefaultRate: selectedAllowance.defaultRate
    });
  };

  $scope.removeDefaultAllowance = function(index) {
    $scope.staff.defaultPaytypes.splice(index, 1);
  };
}]);
